import React, { useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../components/Loader";
import { AiOutlineCaretDown } from "react-icons/ai";
import ChartLine from "../components/ChartLine";

const Cones = () => {
  const { cone_list, cone_loading } = useSelector((state) => state.cones);
  const { date, current_tab } = useSelector((state) => state.other);
  const [id, setId] = useState("");

  const data1 = [];
  for (let j = 0; j < cone_list.length; j++) {
    const data = [];
    for (let i = 0; i < cone_list[j].data.length; i++) {
      const element = {
        name: cone_list[j]?.data[i]?.datetime,
        median: cone_list[j].median,
        count: cone_list[j]?.data[i]?.count,
      };
      data.push(element);
    }
    data1.push({ name: cone_list[j].uuid, data: data, show: false });
  }
  return (
    <div className="main-home-container">
      <div className="date-picker-header">
        <div className="title">Cones Count</div>
        <div style={{ maxWidth: "20%", width: "100%" }} />
        <div className="title" style={{ color: "darkblue" }}>
          {date.start + "  " + "-" + "  " + date.end}
        </div>
      </div>
      {cone_loading ? (
        <Loader />
      ) : (
        <div className="">
          {data1?.map((v, i) => (
            <div key={i} className={`${i + 1 == id && "lightblue"} bg mb10`}>
              <div
                className="container"
                onClick={() => setId(i + 1 == id ? "" : i + 1)}
              >
                <div className="temp-heading"> {v?.name}</div>
                <AiOutlineCaretDown size={20} />
              </div>
              {i + 1 == id &&
                (v.data.length != 0 ? (
                  <div>
                    <ChartLine data={v.data} dataKey="count" />
                    <div className="title-value">
                      Mean :<span>{cone_list[i]?.mean}</span>
                    </div>
                    <div className="title-value">
                      Median :<span>{cone_list[i]?.median}</span>
                    </div>
                    <div className="title-value">
                      Mode :<span>{cone_list[i]?.mode}</span>
                    </div>
                    <div className="title-value">
                      Standard Deviation :<span>{cone_list[i]?.sd}</span>
                    </div>
                  </div>
                ) : (
                  <div className="no-data ">No data</div>
                ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Cones;
